<template>
    <div>
      <label class="item-name"><i class="required" v-show="component.properties.required">*</i>{{initComponent.name}}</label>
      <div class="component-content">
        <el-input :class="{onlyread:component.properties.readonly}" disabled/>
      </div>
    </div>
</template>

<script>
import { componentMixin } from '../mixins'
export default {
  name: 'rc-date',
  props: ['initComponent'],
  mixins: [ componentMixin ],
  data () {
    return {
      component: this.initComponent
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/form/components/date/rc-date.vue